import React, { useRef } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import style from './Tabs.module.css';

export function Tabs({ children, selectedIndex = 0, onTabChange }) {
  const handleTabChange = (index) => {
    onTabChange(index);
  };

  const handleClick = (index) => handleTabChange(index);

  const tabRefs = useRef({});

  const onKeyDown = (event) => {
    const count = children.length;
    const nextTabIdx = (selectedIndex + 1) % count;
    const prevTabIdx = (selectedIndex - 1 + count) % count;
    const firstTabIdx = 0;
    const lastTabIdx = count - 1;

    const keyMapNewIdx = {
      ArrowRight: nextTabIdx,
      ArrowLeft: prevTabIdx,
      Home: firstTabIdx,
      End: lastTabIdx,
    };

    const newIdx = keyMapNewIdx[event.key];

    if (newIdx !== undefined) {
      event.preventDefault();
      const tab = tabRefs.current[newIdx];
      if (tab) {
        tab.focus();
        tab.scrollIntoView();
      }
      handleTabChange(newIdx);
    }
  };

  return (
    <div className={style.tabs}>
      <div className={style.tabList}>
        {children.map((child, index) => {
          const isActive = selectedIndex === index;
          return (
            <button
              key={`tab-${child.props.uniqueKey}`}
              type="button"
              className={cx({
                [style.tabListItem]: true,
                [style.tabListActive]: isActive,
              })}
              ref={(element) => {
                tabRefs.current[index] = element;
              }}
              onClick={() => handleClick(index)}
              onKeyDown={onKeyDown}
            >
              {child.props.title}
            </button>
          );
        })}
      </div>
      <div className={style.tabContent}>
        {children.map((child, index) => {
          const isActive = selectedIndex === index;
          return isActive ? child.props.children : undefined;
        })}
      </div>
    </div>
  );
}

Tabs.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
  selectedIndex: PropTypes.number,
  onTabChange: PropTypes.func.isRequired,
};

export default Tabs;
